"use strict";

var _classCallCheck = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _web3Utils = require("web3-utils");

var _Hash = _interopRequireDefault(require("./models/Hash.js"));

var _FDSSwarmFeeds = _interopRequireDefault(require("./FDS-SwarmFeeds.js"));

var _FDSCrypto = _interopRequireDefault(require("./FDS-Crypto.js"));

var _Contact = _interopRequireDefault(require("./models/Contact.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Copyright 2019 The FairDataSociety Authors
// This file is part of the FairDataSociety library.
//
// The FairDataSociety library is free software: you can redistribute it and/or modify
// it under the terms of the GNU Lesser General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// The FairDataSociety library is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
// GNU Lesser General Public License for more details.
//
// You should have received a copy of the GNU Lesser General Public License
// along with the FairDataSociety library. If not, see <http://www.gnu.org/licenses/>.
// stores files, values, contacts and encrypted values


var SwarmStore =
/*#__PURE__*/
function () {
  /**
   * 
   * @param {any} config configuration settings
   * @param {any} Account to use
   */
  function SwarmStore(config, Account) {
    _classCallCheck(this, SwarmStore);

    this.config = config;
    this.Account = Account;
    this.Store = Account.Store;
    this.SF = new _FDSSwarmFeeds.default(config.swarmGateway);
  }
  /**
   * 
   * @param {any} storerAccount account
   * @param {any} hash location 
   * @param {any} decryptProgressCallback callback
   * @param {any} downloadProgressCallback callback
   * @returns {any} decrypted file
   */


  _createClass(SwarmStore, [{
    key: "retrieveFile",
    value: function retrieveFile(storerAccount, hash) {
      var decryptProgressCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console.log;
      var downloadProgressCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : console.log;
      return this.Store.getDecryptedFile(hash, storerAccount.privateKey, decryptProgressCallback, downloadProgressCallback);
    }
    /**
     * init stored files
     * @param {any} storerAccount account
     */

  }, {
    key: "initStored",
    value: function initStored(storerAccount) {
      this.storeEncryptedValue('stored-1.0', '{"storedFiles":[]}', storerAccount, storerAccount.privateKey);
    }
    /**
     * get stored values
     * @param {any} query to retreive values, will be used later
     * @param {any} storerAccount account 
     * @returns {any} array of hashes 
     */

  }, {
    key: "getStored",
    value: function getStored(query, storerAccount) {
      return this.retrieveDecryptedValue('stored-1.0', storerAccount.address, storerAccount.privateKey).then(function (response) {
        var storedFiles = JSON.parse(response).storedFiles;
        var storedHashes = storedFiles.map(function (f) {
          var h = new _Hash.default(f, storerAccount);
          return h;
        });
        return storedHashes;
      }).catch(function (error) {
        if (error.response.status === 404) {
          return [];
        } else {
          throw new Error(error);
        }
      });
    }
    /**
     * Store file
     * @param {any} storerAccount account 
     * @param {any} file file
     * @param {any} encryptProgressCallback callback
     * @param {any} uploadProgressCallback callback
     * @param {any} progressMessageCallback callback
     * @returns {any} hash encrypted value
     */

  }, {
    key: "storeFile",
    value: function storeFile(storerAccount, file, encryptProgressCallback, uploadProgressCallback, progressMessageCallback) {
      var _this = this;

      return this.Store.storeEncryptedFile(file, storerAccount.privateKey, encryptProgressCallback, uploadProgressCallback, progressMessageCallback).then(function (hash) {
        return _this.getStored('all', storerAccount).then(function (storedFiles) {
          storedFiles.push(hash.toJSON());
          return _this.storeEncryptedValue('stored-1.0', JSON.stringify({
            storedFiles: storedFiles
          }), storerAccount, storerAccount.privateKey);
        });
      });
    } // contacts

    /**
     * Init contacts
     * @param {any} storerAccount account
     * @returns {any} result 
     */

  }, {
    key: "initContacts",
    value: function initContacts(storerAccount) {
      return this.storeEncryptedValue('contacts-1.0', '[]', storerAccount, storerAccount.privateKey);
    }
    /**
     * Get contacts
     * @param {any} storerAccount account
     * @returns {any} contacts 
     */

  }, {
    key: "getContacts",
    value: function getContacts(storerAccount) {
      // debugger
      return this.retrieveDecryptedValue('contacts-1.0', storerAccount.address, storerAccount.privateKey).then(function (contactsJSON) {
        var contacts = JSON.parse(contactsJSON);
        return contacts.map(function (c) {
          return new _Contact.default(c);
        });
      }).catch(function (error) {
        if (error.response.status === 404) {
          return [];
        } else {
          throw new Error("couldn't retrieve contacts: ".concat(error));
        }
      });
    }
    /**
     * Store contact
     * @param {any} storerAccount account 
     * @param {any} contact to store
     * @returns {any} result
     */

  }, {
    key: "storeContact",
    value: function storeContact(storerAccount, contact) {
      var _this2 = this;

      return this.getContacts(storerAccount).then(function (contacts) {
        var flatContacts = contacts.map(function (c) {
          return c.toJSON();
        });
        flatContacts.push(contact.toJSON());
        var contactsJSON = JSON.stringify(flatContacts);
        return _this2.storeEncryptedValue('contacts-1.0', contactsJSON, storerAccount, storerAccount.privateKey);
      });
    } // values

    /**
     * Store value
     * @param {string} key name
     * @param {string} value to store
     * @param {any} storerAccount account 
     * @returns {any} result
     */

  }, {
    key: "storeValue",
    value: function storeValue(key, value, storerAccount) {
      return this.SF.set(storerAccount.address, key, storerAccount.privateKey, value);
    }
    /**
     * Retrieve (get) value
     * @param {any} key name 
     * @param {any} storerAccount account
     * @returns {string} value
     */

  }, {
    key: "retrieveValue",
    value: function retrieveValue(key, storerAccount) {
      return this.SF.get(storerAccount.address, key);
    } // encrypted values

    /**
     * store encrypted value
     * @param {string} key name
     * @param {string} value to store
     * @param {string} storerAccount account 
     * @param {string} password to use
     * @returns {any} result 
     */

  }, {
    key: "storeEncryptedValue",
    value: function storeEncryptedValue(key, value, storerAccount, password) {
      var _this3 = this;

      var iv = _FDSCrypto.default.generateRandomIV();

      return _FDSCrypto.default.encryptString(value, password, iv).then(function (encryptedString) {
        var ivAndEncryptedString = '0x' + iv.toString('hex') + encryptedString;
        return _this3.SF.set(storerAccount.address, key, storerAccount.privateKey, ivAndEncryptedString);
      });
    }
    /**
     * retrieve decrypted value
     * @param {string} key name 
     * @param {string} address to use
     * @param {string} password to use
     * @returns {string} decrypted value
     */

  }, {
    key: "retrieveDecryptedValue",
    value: function retrieveDecryptedValue(key, address, password) {
      return this.SF.get(address, key, 'arraybuffer').then(function (encryptedBuffer) {
        var ivAndEncryptedString = encryptedBuffer.toString('hex');
        var encryptedString = ivAndEncryptedString.substring(32);
        var iv = Buffer.from(ivAndEncryptedString.substring(0, 32), 'hex');
        return _FDSCrypto.default.decryptString(encryptedString, password, iv);
      });
    }
    /**
     * retrieve decrypted value
     * @param {string} key name 
     * @param {string} address to use
     * @param {string} password to use
     * @returns {string} decrypted value
     */

  }, {
    key: "retrieveUnencryptedValue",
    value: function retrieveUnencryptedValue(key, address) {
      return this.SF.get(address, key, 'arraybuffer').then(function (t) {
        var ivAndEncryptedString = (0, _web3Utils.bytesToHex)(encryptedBuffer);
        var iv = ivAndEncryptedString.substring(0, 34);
        var encryptedString = ivAndEncryptedString.substring(34);
        return _FDSCrypto.default.decryptString(encryptedString, password, iv);
      });
    }
  }]);

  return SwarmStore;
}();

var _default = SwarmStore;
exports.default = _default;
module.exports = exports.default;